import { useQuery } from 'react-query';
import { ApiFactory } from '@/utils/apiFactory';
import { exceptionProcessorForQuery } from '@/services/infrastructure/exceptionProcessorForQuery';
import tryCatch from '@/services/infrastructure/tryCatch';

export const createKeyForGetPurgeJobTask = ({ spaceId, projectId, jobId, taskId }) => [
  // `/spaces/${spaceId}/projects/${projectId}/purge-jobs/${jobId}`,
  `/spaces/${spaceId}/projects/${projectId}/purge-jobs/${jobId}/tasks/${taskId}`
];
export const useQueryToGetPurgeJobTask = (
  { spaceId, projectId, jobId, taskId },
  options = null,
  exceptionHandler = exceptionProcessorForQuery()
) =>
  useQuery(
    createKeyForGetPurgeJobTask({ spaceId, projectId, jobId, taskId }),
    async (context) =>
      tryCatch(async () => {
        const response = await ApiFactory.cpdV3({
          method: 'get',
          url: `/purge-jobs/${jobId}/tasks/${taskId}`,
          headers: {
            'cloudplex-space-id': spaceId,
            'cloudplex-project-id': projectId
          },
          signal: context.signal
        });
        return response.data;
      }, exceptionHandler),
    { ...options }
  );
